import { View } from "@react-pdf/renderer";
import ListItem from "./listItem";

function InsuredInfo({ quoteData }) {
  return (
    <View
      style={{
        width: "700px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
        marginTop: 10,
      }}
    >
      <View
        style={{
          width: "80%",
          height: 20,
          backgroundColor: "#000",
        }}
      />
      <View
        style={{
          width: "80%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
          border: "1.5px solid black",
        }}
      >
        <ListItem item="Insured Name" value={quoteData.insuredName} whiteBg />
        <ListItem item="Address" value={quoteData.address} />
        <ListItem
          item="Policy Term"
          value={`From: ${quoteData.policy_term.from}        To: ${quoteData.policy_term.to}`}
          whiteBg
        />
        <ListItem item="Broker Contact" value={quoteData.broker} />
        <ListItem
          item="Issued On"
          /*         value="December 11, 2023 07:57:21 CST (Central Stantard Time)" */
          value={quoteData.issuedOn}
          whiteBg
        />
      </View>
    </View>
  );
}
export default InsuredInfo;
